import lodashFind from "lodash/find";
import { Option } from "ui";

interface useSelectProps {
  options: Option[];
  onSelect?: () => void;
  multiple: boolean;
  value: string[] | string | undefined | null;
  onChange: (value: string[] | string) => void;
}

// Рекурсивна функція для збору всіх значень з вкладених опцій
const getAllNestedValues = (nestedOptions: Option[]): string[] => {
  const values: string[] = [];

  nestedOptions.forEach((option) => {
    values.push(option.value);
    if (option.nestedOptions && option.nestedOptions.length > 0) {
      values.push(...getAllNestedValues(option.nestedOptions));
    }
  });

  return values;
};

const useSelect = ({
  options,
  multiple,
  value,
  onChange,
  onSelect
}: useSelectProps) => {
  const findSelectedOptions = (
    valueArray: string[] | string | undefined | null
  ) => {
    if (multiple && Array.isArray(valueArray)) {
      return valueArray
        .map((v) => lodashFind(options, ["value", v]))
        .filter((option) => option !== undefined);
    }
    return lodashFind(options, ["value", valueArray]);
  };
  const selectedOption = findSelectedOptions(value);

  const onSelectOption = (selectedValue: string) => {
    if (multiple) {
      if (Array.isArray(value)) {
        const isSelected = value.includes(selectedValue);
        const targetOption = options.find(
          (option) => option.value === selectedValue
        );

        let newValue: string[];

        if (isSelected) {
          // При відміні вибору (unselect) видаляємо основне значення та всі вкладені
          const valuesToRemove = [selectedValue];

          if (
            targetOption?.nestedOptions &&
            targetOption.nestedOptions.length > 0
          ) {
            valuesToRemove.push(
              ...getAllNestedValues(targetOption.nestedOptions)
            );
          }

          newValue = value.filter((v) => !valuesToRemove.includes(v));
        } else {
          // При виборі додаємо тільки основне значення
          newValue = [...value, selectedValue];
        }

        onChange(newValue);
      } else {
        onChange([selectedValue]);
      }
    } else {
      onChange(selectedValue);
    }
    onSelect?.();
  };

  return {
    selectedOption,
    onSelectOption
  };
};

export default useSelect;
